import { wgDomains2 } from "@/components/common/GoogleAd1/config1";
import { miQsWeatherDomains } from "@/constants/domain.config";
import { checkTestHost, flatOmit, getSearchParam, isInDomainMap } from "@/utils";
import { isShowNews1 } from "@/utils/isShowNews1";
import { getCurrentAdScenario } from "../useAdScenario";
import { SideAdWaterfall } from "./shared";

/** Home VendorLayout 广告位：position-21 / position-22 / position-23 */
export function useAdCpt1(position: string): JSX.Element | null {
  const { hostName, domain } = useHostName();
  const { isTranTabAdScenario } = getCurrentAdScenario();
  const isMiwgHost = [...domainMap["miwg"]].includes(hostName);
  const { pathname } = useLocation();

  if (isShowNews1().validMain) {
    return null;
  }

  const googleAd1Ad2Index4 = useGoogleAd1("ad2", 4);
  const googleAd1Ad1Index0 = useGoogleAd1("ad1", 0);
  const googleAd1Ad2Index0 = useGoogleAd1("ad2", 0);
  const googleAd1Ad2Index1 = useGoogleAd1("ad2", 1);
  const googleAd1Ad1Index1 = useGoogleAd1("ad1", 1);
  const yanDexAd2Index1 = useYanDex("ad2", 1);

  switch (position) {
    case "position-21":
      return resolvePosition21();
    case "position-22":
      return resolvePosition22();
    case "position-23":
      return resolvePosition23();
    default:
      return null;
  }

  function resolvePosition21(): JSX.Element | null {
    if (miQsWeatherDomains.includes(hostName)) {
      return <GoogleAd1 {...googleAd1Ad2Index0} dataPosition={position} />;
    }
    if (isTranTabAdScenario) {
      return null;
    }

    if (["/home"].some(p => pathname.startsWith(p)) && [...wgDomains1, ...wgDomains3].includes(hostName)) {
      return <GoogleAd1 dataPosition={position} {...googleAd1Ad2Index4} />;
    }

    if (dexLinks.includes(domain)) {
      return <YanDexAd dataPosition={position} {...yanDexAd2Index1} />;
    }

    if (checkTestHost(flatOmit(domainMap, ["wi"])) || isInDomainMap(domainMap, ["wi"])) {
      const adProps = isMiwgHost ? googleAd1Ad1Index0 : googleAd1Ad2Index1;
      return <GoogleAd1 dataPosition={position} {...adProps} />;
    }

    return null;
  }

  function resolvePosition22(): JSX.Element | null {
    if ([...domainMap["wg"]].includes(hostName) && ![...wgDomains1, ...wgDomains2].includes(hostName)) {
      return <GoogleAd1 dataPosition={position} {...googleAd1Ad1Index0} />;
    }

    return null;
  }

  function resolvePosition23(): JSX.Element | null {
    if ([...domainMap["wg"], ...domainMap["miwg"]].includes(hostName) && ![...wgDomains1].includes(hostName)) {
      return <GoogleAd1 dataPosition={position} {...googleAd1Ad1Index1} />;
    }

    return null;
  }
}

export function useAdCpt2(position: string): JSX.Element | null {
  const { hostName, domain } = useHostName();
  const { isTranTabAdScenario } = getCurrentAdScenario();

  const googleAd1Ad2Index0 = useGoogleAd1("ad2", 0);
  const googleAd1Ad1Index0 = useGoogleAd1("ad1", 0);
  const googleAd1Ad3Index0 = useGoogleAd1("ad3", 0);
  const googleAd2Ad1Index0 = useGoogleAd2("ad1", 0);
  const googleAd2Ad2Index0 = useGoogleAd2("ad2", 0);
  const yanDexAd1Index0 = useYanDex("ad1", 0);

  switch (position) {
    case "position-34":
      return (
        <SideAdWaterfall
          position={position}
          config={{
            miQsIndex: 1,
            tranIndex: 0,
            yanDexIndex: 2,
            newsGoogleAd2Index: 2,
            nonWiGoogleAd1Index: 2,
          }}
        />
      );
    case "position-08":
      if (miQsWeatherDomains.includes(hostName)) {
        return (
          <GoogleAd1
            dataPosition={position}
            {...googleAd1Ad1Index0}
            {...([...miQsWeatherDomains].includes(hostName) ? { isLazyLoad: false } : {})}
          />
        );
      }
      if ([...domainMap["v-ls"]].includes(hostName)) {
        return <GoogleAd1 dataPosition={position} {...googleAd1Ad2Index0} />;
      }
      if (dexLinks.includes(domain)) {
        return <YanDexAd dataPosition={position} {...yanDexAd1Index0} />;
      }
      if (isShowNews1().validMain) {
        const channel = getSearchParam("channel") || "";
        const adConfig = channel === "v_ls_dismore" ? googleAd2Ad2Index0 : googleAd2Ad1Index0;
        return <GoogleAd2 dataPosition={position} {...adConfig} />;
      }
      if ([...miwgDomain1, ...wgDomains3].includes(hostName)) {
        return <GoogleAd1 dataPosition={position} {...googleAd1Ad2Index0} />;
      }
      // 排除掉wg相关域名
      if (checkTestHost(domainLinks) || isInDomainMap(domainMap, ["wg"])) {
        const adConfig = {
          ...googleAd1Ad1Index0,
          ...(isTranTabAdScenario || [...wwwDomain1].includes(hostName) ? { isLazyLoad: false } : {}),
        };
        return <GoogleAd1 dataPosition={position} {...adConfig} />;
      }
      if ([...wgDomains1].includes(hostName)) {
        return <GoogleAd1 dataPosition={position} {...googleAd1Ad3Index0} />;
      }

      return null;
    case "position-35":
      return (
        <SideAdWaterfall
          position={position}
          config={{
            miQsIndex: 2,
            tranIndex: 1,
            yanDexIndex: 3,
            newsGoogleAd2Index: 3,
            nonWiGoogleAd1Index: 3,
          }}
        />
      );

    default:
      return null;
  }
}
